import { Component, ViewChild, Injector } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { AutomatedPermissionWizardService, Pagination, PermissionSetService, PermissionTemplateService, BranchService, CompanyService, LocationService} from 'blg-akaun-ts-lib';
import { PermissionFacade } from '../../../../../../modules/permission/facades/permission.facade';
import { RolePermSetListingSearchModel } from '../../../../../../models/advanced-search-models/role-perm-set-listing-search.model';
import { RolePermSetModel } from '../../../../../../models/role-permissions.model';
import { gridOptionsServerSide, pageFiltering, pageSorting, serverSideClear } from '../../../../../../listing.utils';
import { PaginationComponent } from '../../../../../../utilities/pagination/pagination.component';
import { ViewColumnComponent } from '../../../../../../view-column.component';
import { AppConfig } from '../../../../../../visa';
import { forkJoin, iif, Observable, of } from 'rxjs';
import { filter, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PermissionStates } from '../../../../permission-controller/root';
import { RolePermActions } from '../../../../role-permissions-controller/actions';
import { RolePermSelectors } from '../../../../role-permissions-controller/selectors';
import { RolePermStates } from '../../../../role-permissions-controller/states';
import { SearchQueryModel } from '../../../../../../models/query.model';
import { SessionSelectors } from '../../../../../../modules/session/session-controller/selectors';
import { SessionStates } from '../../../../../../modules/session/session-controller/states';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from "@ngx-translate/core";

interface LocalState {
  deactivateReturn: boolean;
  selectedIndex: number;
  deactivateAdd: boolean;
  deactivateList: boolean;
}

@Component({
  selector: 'app-copy-permission-set',
  templateUrl: './role-permission-set-copy.component.html',
  styleUrls: ['./role-permission-set-copy.component.scss']
})

export class RolePermissionSetCopyFromComponent extends ViewColumnComponent {

  @ViewChild(PaginationComponent, {static: false})
  private paginationComponent: PaginationComponent;

  private subSink = new SubSink;
  private localState: LocalState;
  protected readonly index = 7;

  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateAdd$ = this.componentStore.select(state => state.localState.deactivateAdd);
  readonly deactivateList$ = this.componentStore.select(state => state.localState.deactivateList);

  public form: FormGroup;
  apiVisa = AppConfig.apiVisa;

  searchModel = RolePermSetListingSearchModel;

  // initial ag grid state
  gridApi;

  gridOptions: any;

  columnsDefs;

  rowSelection = 'multiple';
  selectedRows: any[] = []; // This will store the selected rows from ag-grid

  tenantGuid;
  appletGuid: string = sessionStorage.getItem('appletGuid');
  roleGuid: string;
  roleToGuid: string;

  companyGuid: string;
  companyGuidList: any[];

  //translation variable
  copy_text: string;
  branch_text: string;
  location_text: string;
  select_permission_sets_text: string;
  perm_set_code_text: string;
  perm_set_name_text: string;
  perm_template_name_text: string;

  constructor(
    private permSetService: PermissionSetService,
    private permTemplateService: PermissionTemplateService,
    private permissionWizardService: AutomatedPermissionWizardService,
    private toastr: ToastrService,
    // private branchService: BranchService,
    // private companyService: CompanyService,
    // private locationService: LocationService,
    private readonly store: Store<PermissionStates>,
    private viewColFacade: PermissionFacade,
    private readonly sessionStore: Store<SessionStates>,
    private componentStore: ComponentStore<{localState: LocalState}>,
    private injector: Injector
  ) {
    super();
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.copy_text = res.copy;
        this.branch_text = res.branch;
        this.location_text = res.location;
        this.select_permission_sets_text = res.select_permission_sets;
        this.perm_set_code_text = res.perm_set_code;
        this.perm_set_name_text = res.perm_set_name;
        this.perm_template_name_text = res.perm_template_name;
      });
    } else {
      this.copy_text = 'Copy';
      this.branch_text = 'Branch';
      this.location_text = 'Location';
      this.select_permission_sets_text = 'Select Permission Sets';
      this.perm_set_code_text = 'Perm Set Code';
      this.perm_set_name_text = 'Perm Set Name';
      this.perm_template_name_text = 'Perm Template Name';
    }
  }

  ngOnInit() {
    // initial configurations for local state

    this.gridOptions = { ...gridOptionsServerSide };
    this.gridOptions.rowSelection = 'multiple';


    this.form = new FormGroup({
      roleFromGuid: new FormControl('', Validators.required),
      companies: new FormControl('', Validators.required),
      branches: new FormControl('', Validators.required),
      locations: new FormControl('', Validators.required),
    });

    this.subSink.sink = this.localState$.subscribe( a => {
      this.localState = a;
      this.componentStore.setState( {localState: a} );
    });

    this.subSink.sink = this.store.select(RolePermSelectors.selectGuid)
    .subscribe(x => {
      this.roleToGuid = x;
    });

    const AppletLoginSubjectLink$ = this.sessionStore.select(SessionSelectors.selectAppletLoginSubjectLink);

    this.subSink.sink = AppletLoginSubjectLink$.subscribe(session => {
      if(session) {
        console.log("Session tenant guid: ",session);
        this.tenantGuid = session.tenant_guid.toString();
      }
    })

    this.columnsDefs = [
      {
        headerName: '',
        field: 'app_perm_set_hdr.guid',
        valueFormatter: params => '',
        checkboxSelection: true, // Ensure checkbox selection is enabled
        floatingFilter: false,
        sortable: false,
        minWidth: 0
      },
      {
        headerName: this.perm_set_code_text,
        field: 'app_perm_set_hdr.code',
        cellStyle: {textAlign: 'left'}
      },
      {
        headerName: this.perm_set_name_text,
        field: 'app_perm_set_hdr.name',
        cellStyle: {textAlign: 'left'}
      },
      {
        headerName: this.perm_template_name_text,
        field: 'app_perm_template_hdr.name',
        cellStyle: {textAlign: 'left'}
      }
    ]
  }

  /**
   * This function is called when AG grid is first initialised and initally
   * sets the datasource of the grid.
   *
   * @param params : grid parameters
   */
  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();

    // Subscription to form value changes
    this.subSink.sink = this.form.get('roleFromGuid').valueChanges.subscribe(guid => {
      if (guid) {
        this.roleGuid = guid;
        this.getPermSetsInRole();

        // Resize columns
        const allColIds = params.columnApi.getAllColumns().map(x => x.colId);
        params.columnApi.autoSizeColumns(allColIds);
      }
    });

    // Subscription to store changes
    this.subSink.sink = this.store.select(RolePermSelectors.selectUpdateAllPermSetListing)
      .subscribe(x => {
        if (x) {
          this.getPermSetsInRole();
          this.store.dispatch(RolePermActions.setUpdateAllPermSetListing({ update: false }));
        }
      });
  }


  /**
   * Returns the datasource for the AG grid.
   *
   * @param conditionalCriteria : any custom criteria to search for in the API
   * @returns the datasource
   */
  getDatasource(conditionalCriteria?) {

    let offset = 0;
    let limit = this.paginationComponent.rowPerPage;

    let criteria = [
      {columnName: 'calcTotalRecords', operator: '=', value: 'true'}
    ];

    if (conditionalCriteria) {
      criteria = criteria.concat(conditionalCriteria);
    }

    return {
      getRows: grid => {

        const sortModel = grid.request.sortModel;
        const filterModel = grid.request.filterModel;
        const sortOn = pageSorting(sortModel);
        const filter = pageFiltering(filterModel);

        // only change offset and limit if no filterModel or sortModel is present
        if (Object.keys(filterModel).length == 0 && sortModel.length == 0) {
          offset = grid.request.startRow;
          limit = grid.request.endRow - offset;
        }

        const pagination = new Pagination(offset, limit, criteria);
        this.subSink.sink = this.permSetService.getByCriteria(pagination, this.apiVisa)
          .pipe(
            mergeMap(a => {
              const source: Observable<RolePermSetModel>[] = [];
              a.data.forEach((b) => {
                const newModel: RolePermSetModel = new RolePermSetModel();
                newModel.app_perm_set_hdr = b.app_perm_set_hdr;
                newModel.app_perm_set_lines = b.app_perm_set_lines;
                const permTemplate$ = this.getPermTemplate(b.app_perm_set_hdr.parent_guid.toString(), this.appletGuid, this.tenantGuid);
                const result$ = permTemplate$
                .pipe(
                  map(c => {
                    newModel.app_perm_template_hdr = c.app_perm_template_hdr;

                    return newModel;
                  })
                );
                // push new observable into array
                source.push(result$);
              });
              return iif(() => source.length > 0,
              forkJoin(source).pipe(map(x => {
                return {...a,
                data: x}
              })),
              of({...a, data: [], totalRecords: 0}))
            })
          ).subscribe(a => {
            // put data into the grid
            console.log("DEBUG::::a", a)
            const data = sortOn(a.data).filter(entity => filter.by(entity));
            const totalRecords = filter.isFiltering ? a.totalRecords : data.length;
            grid.successCallback(data, totalRecords);
          }, err => {
            grid.failCallback();
          })
      }
    }
  }

  /**
   * Returns all the guids of all the permission sets in this role.
   *
   */
  getPermSetsInRole() {
    /**
     * Replaces the raw SELECT that went through SubQueryService:
     *
     *   FROM app_perm_set_hdr hdr
     *   INNER JOIN app_perm_assignee_target_link link ON hdr.guid = link.perm_set_hdr_guid
     *   WHERE link.assignee_hdr_table = 'app_mst_role'
     *     AND link.assignee_hdr_guid = '<role>'
     *     AND hdr.applet_guid = '<applet>'
     *     AND hdr.status != 'DELETED' AND link.status != 'DELETED'
     *
     * AppPermissionSetUow.generateWhereClauseByCriteria performs the same join
     * and applies `assignee_hdr_table`, `assignee_hdr_guid` and `applet_guid` as
     * criteria, with `status != 'DELETED'` as its default on both tables.
     */
    const datasource = this.getDatasource(this.buildSearchCriteria());
    this.gridApi.setServerSideDatasource(datasource);
  }

  /**
   * Returns an observable containing the permission template with this guid.
   *
   * @param guid : guid of the permission template
   * @returns an observable of the permission template
   */
 getPermTemplate(guid, appletGuid: string, tenantGuid: string) {
  return this.permTemplateService.getByLogin(appletGuid, tenantGuid, this.apiVisa)
    .pipe(
      map(a => a.data), // Extract data property
      map(data => this.filterData(guid, data)) // Apply your filtering logic
    );
}

// Add a custom filterData function to filter the data
filterData(guid: string, data: any): any {
  // Use the equality operator (===) for comparison
  let filteredData = data.filter(item => item.app_perm_template_hdr.guid === guid);
  return filteredData[0];
}

  // getPermTemplate(guid: string) {
  //   return this.permTemplateService.getByGuid(guid, this.apiVisa)
  //     .pipe(
  //       map(a => a.data)
  //     )
  // }

  /**
   * This function is called every time the user searches something in the
   * search bar.
   *
   * @param e : the search model
   */
   /**
   * Runs the search bar's query against the permission-set listing's own
   * endpoint.
   *
   * Replaces the raw SQL that <app-advanced-search> built from
   * RolePermSetListingSearchModel and posted to SubQueryService (a SELECT over
   * app_perm_set_hdr INNER JOINed to app_perm_assignee_target_link and
   * app_perm_template_hdr, with the assignee and applet scoping appended here).
   * The search bar is now <app-advanced-search-general>, which emits the keyword
   * and the form value instead of SQL.
   *
   * AppPermissionSetUow.generateWhereClauseByCriteria makes both joins itself and
   * honours `search_word` (bound ILIKE over the header's code and name),
   * `perm_template` (ILIKE on the joined template's name), `applet_guid`, and
   * `assignee_hdr_table` / `assignee_hdr_guid` for the link scoping -- the fields
   * added to AppPermissionSetQueryCriteria for exactly this move.
   *
   * The assignee and applet scoping the old SQL carried is re-seeded on every
   * search, so a search never widens the listing beyond this role and applet.
   */
  onSearch(e: SearchQueryModel) {
    const datasource = this.getDatasource(this.buildSearchCriteria(e));
    this.gridApi.setServerSideDatasource(datasource);
  }

  /**
   * Criteria for the permission sets assigned to this role in this applet, plus
   * whatever the search bar asked for.
   */
  buildSearchCriteria(e?: SearchQueryModel) {
    const criteria: any[] = [
      { columnName: 'assignee_hdr_table', operator: '=', value: 'app_mst_role' },
      { columnName: 'assignee_hdr_guid', operator: '=', value: this.roleGuid },
      { columnName: 'applet_guid', operator: '=', value: this.appletGuid }
    ];
    if (!e || e.isEmpty) {
      return criteria;
    }
    if (e.keyword) {
      return criteria.concat([
        { columnName: 'search_word', operator: '=', value: e.keyword.trim() }
      ]);
    }
    const query: any = e.queryString || {};
    return criteria.concat(
      [{ columnName: 'perm_template', operator: '=', value: query.permTemplate }]
        .filter(condition => condition.value)
    );
  }

  onCompanySelected(e: any[]) {
    if (e && e.length > 0) {
      this.companyGuid = e.length === 1 ? e[0].guid : null;
      this.companyGuidList = e.map(company => company.guid);
    } else {
      this.companyGuid = null;
      this.companyGuidList = [];
    }
  }

  disableSubmit(): boolean {
    // Check if all form fields have values
    const allFieldsSelected = Object.keys(this.form.controls).every(key => {
      const control = this.form.controls[key];
      const controlValue = control.value;
      // Adjust this check based on the expected type of the value
      if (Array.isArray(controlValue)) {
        return controlValue.length > 0;
      }
      return controlValue !== null && controlValue !== undefined && controlValue.toString().trim().length > 0;
    });


    // Check if at least one row is selected in ag-grid
    const atLeastOneRowSelected = this.selectedRows.length > 0;
    return !allFieldsSelected || !atLeastOneRowSelected;
  }

  onRowSelected(event: any): void {
    this.selectedRows = event.api.getSelectedRows();
    this.gridApi = event.api; // Save the grid API for later use
    // console.log("this.selectedRows", this.selectedRows);
  }

  onSubmit(): void {
    if (!this.disableSubmit()) {
      // Handle form submission
      console.log("this.selectedRows22", this.selectedRows);
      const { roleFromGuid, companies, branches, locations } = this.form.value;

      // Assign values to separate variables
      const role = roleFromGuid;
      const company = companies;
      const branch = branches.map(branch => branch.guid);
      const location = locations;

      const permSetLines: any[] = [];
      const permTemplateGuids: string[] = [];
      const autoCreate = false;
      const permissionSetrolePrefix = "";
      const permissionSetPrefix = "";

      // Assuming this.selectedRows is an array of RolePermissionModel
      this.selectedRows.forEach(rolePermissionModel => {
        // Check the value of target_type
        if (rolePermissionModel.app_perm_set_lines[0].target_type === "NA") {
          permSetLines.push(...rolePermissionModel.app_perm_set_lines);
        } else {
          permTemplateGuids.push(rolePermissionModel.app_perm_template_hdr.guid);
        }
      });

      // console.log("permSetLines1", permSetLines);
      // console.log("permTemplateGuids", permTemplateGuids);

      // Collect all the observables into an array
      const permissionRequests = permTemplateGuids.map(templateGuid =>
        this.permissionWizardService.generatePermissions(
          autoCreate,
          templateGuid,
          this.appletGuid,
          company,
          location,
          branch,
          permissionSetrolePrefix,
          permissionSetPrefix,
          this.apiVisa
        )
      );

      if (permissionRequests.length > 0) {
        forkJoin(permissionRequests).subscribe(
          responses => {
            responses.forEach(response => {
              this.toastr.success('Permissions generated successfully!');
              permSetLines.push(...response.data[0].app_perm_set_lines);
            });
            // console.log("permSetLines2222", permSetLines);
            this.store.dispatch(RolePermActions.addPermSetsToRoleInit({ permSetLines: permSetLines, appletGuid: this.appletGuid, roleGuid: this.roleToGuid }));
            this.resetForm();
          },
          error => {
            console.error(error);
            this.toastr.error('Failed to generate permissions!');
          }
        );
      } else {
        // console.log("permSetLines2222", permSetLines);
        this.store.dispatch(RolePermActions.addPermSetsToRoleInit({ permSetLines: permSetLines, appletGuid: this.appletGuid, roleGuid: this.roleToGuid }));
        this.resetForm();
      }
    }
  }

  private resetForm(): void {
    this.form.reset({
      roleFromGuid: '',
      companies: '',
      branches: '',
      locations: ''
    });

    // Unselect grid rows if gridApi is initialized
    if (this.gridApi) {
      this.gridApi.deselectAll();
    }
  }

}
